import React from 'react';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const SlideUpTransition = React.forwardRef(function SlideUpTransition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  // Direction "up" means it slides up when entering (from bottom to center)
  // When exiting, it automatically reverses (from center to bottom)
  return <Slide direction="up" ref={ref} {...props} />;
});

export default SlideUpTransition;
